<!-- 预览抓拍同时展示农事相关信息组件 -->
<template>
    <el-dialog ref="dialog" :visible.sync="dialogShow" @opened="opened" width="80vw" append-to-body custom-class="hs-dialog"
        top="1vh">
        <div slot="title" class="hs-dialog-title fs16 fw-bd xrow ai-c">
            <el-image :src="require('../../../assets/plant/crop.png')" class="w25 mgr5"></el-image>作物生长监控
        </div>
        <el-row>
            <el-col :span="15">
                <div id="video-container"></div>
                <!-- <el-descriptions title="农产品质量全程溯源"></el-descriptions> -->
                <!-- <el-carousel class="carouse" height="calc(80vw * 0.625 * 0.56 - 40px)" :autoplay="false" :loop="false" arrow="always" indicator-position="none" @change="carouselChange" ref="carouse">
                    <el-carousel-item v-for="(image,index) in imageList1" :key="index">
                        <el-image :src="image.Url" fit="scale-down"></el-image>
                    </el-carousel-item>
                </el-carousel> -->
                <!-- <gif :images="imageList" v-else></gif> -->
                <div class="xrow ai-c mgt20">
                    <el-image :src="require('../../../assets/plant/land.png')" class="w25 mgr5"></el-image><span
                        class="fs16 fw-bd color-33">地块信息</span>
                </div>
                <el-descriptions :column="3" border class="mgt20">
                    <el-descriptions-item :span="3">
                        <template slot="label">
                            <i class="el-icon-location"></i>
                            地块位置
                        </template>
                        <div v-if="landInfo && landInfo.location">
                            {{ landInfo.location.province + landInfo.location.city + landInfo.location.district +
                                landInfo.location.town
                                + landInfo.location.street }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-s-order"></i>
                            土壤类型
                        </template>
                        <div v-if="landInfo && landInfo.soilType">{{ landInfo.soilType }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-s-order"></i>
                            养分等级
                        </template>
                        <div v-if="landInfo && landInfo.soilGrade">{{ landInfo.soilGrade }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-reading"></i>
                            种植面积
                        </template>
                        <div v-if="landInfo">{{ landInfo.area }}亩</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-office-building"></i>
                            农场主
                        </template>
                        <div v-if="landInfo && landInfo.user && landInfo.user.name">{{ landInfo.user.name }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            手机号
                        </template>
                        <div v-if="landInfo && landInfo.user && landInfo.user.mobileNumber">{{ landInfo.user.mobileNumber }}
                        </div>
                    </el-descriptions-item>

                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-files"></i>
                            种植方式
                        </template>
                        <div v-if="plant.PlantStyle">{{ plant.PlantStyle }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-date"></i>
                            种植时间
                        </template>
                        <span v-if="plant.BeginTime">{{ plant.BeginTime }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-loading"></i>
                            生长阶段
                        </template>
                        <el-tag size="small" v-if="curPlantStage.Standard">{{ curPlantStage.Standard.StageName }}</el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-date"></i>
                            种植作物
                        </template>
                        <span v-if="landInfo && landInfo.crop && landInfo.crop.name"> {{ landInfo.crop.name }}</span>
                    </el-descriptions-item>
                    <el-descriptions-item :span="3" labelClassName="minw85 w85">
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            农事推荐
                        </template>
                        <span v-html="curPlantStage.Standard.Memo" v-if="curPlantStage.Standard"></span>
                    </el-descriptions-item>
                </el-descriptions>
            </el-col>
            <el-col :span="9">
                <div class="pdl10">
                    <div class="xrow ai-c jc-sb pdb20">
                        <div class="xrow ai-s jc-s">
                            <el-image :src="require('../../../assets/plant/farm.png')" class="w25 mgr5"></el-image>
                            <span class="fs16 fw-bd color-33">农业生产管理</span>
                        </div>
                    </div>
                    <div class="farm-content pdl5" v-loading="farmloading">
                        <el-timeline v-if="growthStagesList.length > 0">
                            <el-timeline-item :timestamp="item.name" placement="top"
                                v-for="(item, index) in growthStagesList" :key="index">
                                <el-card class="mgr20" v-if="item.children.length">
                                    <el-timeline>
                                        <el-timeline-item v-for="(it, subIndex) in item.children" :key="subIndex">
                                            <div class="xrow">
                                                <div><el-image style="width: 60px; height: 60px" :src="it.pictureURL"
                                                        :preview-src-list="[it.pictureURL]">
                                                    </el-image>
                                                </div>
                                                <div class="flex1">
                                                    <div class="xrow mgl10 mgb10" style="color: #008ca5;">
                                                        <div class="flex1">{{ it.editedAt }}</div>
                                                        <div class="flex1" v-if="it.area">面积：{{ it.area }}亩</div>
                                                    </div>
                                                    <div class="mgl10">农事项目：{{ it.farmActivity }}</div>
                                                </div>
                                            </div>
                                        </el-timeline-item>
                                    </el-timeline>
                                </el-card>
                            </el-timeline-item>
                        </el-timeline>
                        <el-empty description="无农事信息" v-else></el-empty>
                    </div>
                </div>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
/**
 * 预览抓拍同时展示农事
 */
import EZUIKit from 'ezuikit-js';
import { mapState } from 'vuex'
import { get } from "@/utils/http";
import { formatDate } from '@/common/util'
import gif from './gif'
import { forEach } from 'lodash'
export default {
    name: 'platimage',
    props: {
        landId: {
            type: String,
            default: ''
        },
        day: {
            type: Number,
            default: 1
        }
    },
    components: { gif },
    data() {
        return {
            encoderId: '',
            curImageDate: '',
            imageList: [],
            imageList1: [],
            curImageIndex: 0,
            dialogShow: false,
            plant: {},
            stages: {},
            farmWay: 'date',
            farmloading: false,
            curPlantStage: { Memo: '' },
            landInfo: null,
            EZU: null,
            cropName: "",
            growthStagesList: []
        }
    },

    computed: {
        ...mapState(['land']),
    },
    watch: {
        dialogShow(val) {
            if (this.EZU && !val) {
                this.EZU.stop();
            }
        }
    },
    methods: {
        ...formatDate,
        show(encoderId, faramId) {
            this.encoderId = encoderId
            // this.curImageDate = time
            this.dialogShow = true;
            this.loadVidoData(encoderId);
            this.getLandDetail(faramId)
            // this.getLandDetail(2305100008)

            // console.log(
            //     'this.curImageDate',
            //     new Date(this.curImageDate).getTime()
            // )
            // this.loadImage()
            // this.loadFarm(this.curImageDate)
        },

        getLandDetail(param) {
            get(`/farmland/device?key=${param}`).then(res => {
                if (res.data) {
                    this.landInfo = res.data;
                    this.cropName = res.data.crop.name;
                    this.loadData()
                }
            })
        },
        loadData() {
            const _that = this;
            Promise.all([_that.getGropList(), _that.getFarmActivityRecord()]).then(res => {
                if (res[0].growthStages) {
                    let temp = [];
                    forEach(res[0].growthStages, it => {
                        let list = [];
                        forEach(res[1], item => {
                            if (item.growthStage === it) {
                                list.push({
                                    ...item,
                                    // pictureURL: item.pictureURL ? item.pictureURL :
                                    //     require(
                                    //         "../../static/warn.png")
                                })
                            }
                        })

                        temp.push({
                            name: it,
                            children: list
                        })
                    });
                    this.growthStagesList = temp
                }

            }).catch(error => {
                console.log("error=", error)
            })
        },
        getGropList() {
            return get(`/base/crop?name=${this.cropName}`).then(res => {
                if (res.data) {
                    return res.data
                }
            })
        },
        getFarmActivityRecord() {
            const item = this.$store.state.currentItem;
            const obj = JSON.parse(item);
            const keys = obj.key;
            return get(`/farmActivityRecord/list?farmlandKey=${keys}&page=1&rows=1000,`).then(res => {

                if (res.data) {
                    return res.data
                }
            })
        },
        loadFarm(endDate) {
            this.farmloading = false
            this.$request('origin', 'plant', {
                LandId: this.land.LandId
            }).then(res => {
                if (res.code === 1) {
                    this.plant = res.data
                    this.$request('origin', 'queryfarm', {
                        // plantId: '6469f462-d77b-4436-a667-b1aef91dc764',
                        EndDate: endDate || '',
                        plantId: this.plant.PlantId
                    }).then(resstate => {
                        if (resstate.code === 1) {
                            let stages = resstate.data
                            if (stages.length > 0) {
                                stages.push({
                                    PlantStageId: '',
                                    CurStageName: '开始',
                                    EnterDate:
                                        stages[stages.length - 1].EnterDate
                                })
                            }
                            this.stages = stages
                            // 找到当前生长期
                            this.curPlantStage = this.stages[0] || { Memo: '' }
                        }
                        this.farmloading = false
                    })
                }
            })
        },
        opened() { },
        close() {
            this.dialogShow = false
        },
        carouselChange(e) {
            let img = this.imageList1[e]
            this.loadFarm(img.DateTime)
            console.log(e)
        },
        loadVidoData(encoderId) {
            const width = document.documentElement.clientWidth * 0.8 * 0.625 - 26;
            const height = document.documentElement.clientHeight * 0.5;
            get(`/metrics/video?key=${encoderId}`).then(res => {
                const url = res.data[1];
                const accessToken = res.data[0];
                if (res.data && res.data.length == 2) {
                    this.EZU = new EZUIKit.EZUIKitPlayer({
                        id: 'video-container', // 视频容器ID
                        accessToken: accessToken,
                        url: url,
                        // template: "security",
                        footer: ["broadcast", "fullScreen"],
                        // plugin: ['talk'],
                        width: width,
                        height: height,
                        handleError: (data) => {
                            //   if (data.retcode === 1003) {
                            //     document.getElementById("video-container-loading-item-0").innerHTML = "";
                            //     setShowResetButton(true)
                            //   }
                            //   //

                        }
                    });
                }


            })
        },
        closeVideo() {
            if (this.EZU) {
                this.EZU.stop();
            }
        }
    }
}
</script>
<style lang='less' scoped>
.farm-content {
    height: 78vh;
    overflow-y: auto;
}

.el-dialog__body {
    padding: 10px 20px;
}

.carouse {
    height: calc(100% * 0.56);
}
</style>
